import ApplicationComponent from "legacy/ApplicationComponent"
import FormGroup from "legacy/FormGroup"
import NextButton from "legacy/boater-reservation-flow/NextButton"
import { validatorFactory } from "legacy/validatorFactory"
import PropTypes from "prop-types"
import React from "react"

class ListedPumpPricesForm extends ApplicationComponent {
  constructor(props) {
    super(props)

    const regularGas = this.props.fuel.find((obj) => obj.name === "Regular Gas")
    const superGas = this.props.fuel.find((obj) => obj.name === "Super Gas")
    const premiumGas = this.props.fuel.find((obj) => obj.name === "Premium Gas")
    const diesel = this.props.fuel.find((obj) => obj.name === "Diesel")
    const propane = this.props.fuel.find((obj) => obj.name === "Propane")

    this.state = {
      processing: false,
      regularGasPrice: this.formatPrice(regularGas.unitPrice),
      regularGasTaxIncluded: regularGas.taxIncluded,
      superGasPrice: this.formatPrice(superGas.unitPrice),
      superGasTaxIncluded: superGas.taxIncluded,
      premiumGasPrice: this.formatPrice(premiumGas.unitPrice),
      premiumGasTaxIncluded: premiumGas.taxIncluded,
      dieselPrice: this.formatPrice(diesel.unitPrice),
      dieselTaxIncluded: diesel.taxIncluded,
      propanePrice: this.formatPrice(propane.unitPrice),
      propaneTaxIncluded: propane.taxIncluded,
      validationErrorMessage: null,
      lastUpdatedAt: this.props.lastUpdatedAt,
    }
    this.validator = validatorFactory({ autoForceUpdate: this })
    this.submit = this.submit.bind(this)
  }

  formatPrice(price) {
    if (price == null) {
      return ""
    }
    return price
  }

  submit() {
    this.validator.showMessages()
    if (this.validator.allValid()) {
      this.setState({
        processing: true,
        validationErrorMessage: null,
      })
      const fuel = {
        diesel_price: this.state.dieselPrice,
        gas_premium_price: this.state.premiumGasPrice,
        gas_regular_price: this.state.regularGasPrice,
        gas_super_price: this.state.superGasPrice,
        propane_price: this.state.propanePrice,
      }
      $.post(
        $context.manageUpdateFuelUrl,
        { fuel },
        (data) => {
          this.setState({
            processing: false,
            validationErrorMessage: null,
            lastUpdatedAt: data.lastUpdatedAt,
          })
        },
        "json"
      ).fail((data) => {
        const errorMessage =
          data.responseJSON.errors ||
          "Something went wrong while updating your pump prices, please contact mayday@dockwa.com for assistance."
        this.setState({
          processing: false,
          validationErrorMessage: errorMessage,
        })
      })
    }
  }

  render() {
    return (
      <div>
        <div className="flex justify-between">
          <h4>Listed Pump Prices</h4>
          <div className="flex items-center gap-6">
            {this.state.lastUpdatedAt && (
              <p className="m-0 text-gray-600">
                Last updated on {this.state.lastUpdatedAt}
              </p>
            )}
            <a className="btn btn-secondary" href={$context.editManageSalesUrl}>
              Go to edit items{" "}
            </a>
          </div>
        </div>
        <hr />
        <div className="grid grid-cols-3 gap-4 lg:grid-cols-6">
          <div className="flex flex-wrap">
            <FormGroup
              className="mb-2"
              inputType="currency"
              label="Regular Gas Price"
              name="regularGasPrice"
              value={this.state.regularGasPrice}
              onChange={this.handleInputChange}
              validation={this.validator.message(
                "regular_gas_price",
                this.state.regularGasPrice,
                "maxDecimalPrecision:4"
              )}
            />
            {this.state.regularGasTaxIncluded && (
              <p className="text-gray-600">Tax included in price</p>
            )}
          </div>
          <div className="flex flex-wrap">
            <FormGroup
              className="mb-2"
              inputType="currency"
              label="Super Gas Price"
              name="superGasPrice"
              value={this.state.superGasPrice}
              onChange={this.handleInputChange}
              validation={this.validator.message(
                "super_gas_price",
                this.state.superGasPrice,
                "maxDecimalPrecision:4"
              )}
            />
            {this.state.superGasTaxIncluded && (
              <p className="text-gray-600">Tax included in price</p>
            )}
          </div>
          <div className="flex flex-wrap">
            <FormGroup
              className="mb-2"
              inputType="currency"
              label="Premium Gas Price"
              name="premiumGasPrice"
              value={this.state.premiumGasPrice}
              onChange={this.handleInputChange}
              validation={this.validator.message(
                "premium_gas_price",
                this.state.premiumGasPrice,
                "maxDecimalPrecision:4"
              )}
            />
            {this.state.premiumGasTaxIncluded && (
              <p className="text-gray-600">Tax included in price</p>
            )}
          </div>
          <div className="flex flex-wrap">
            <FormGroup
              className="mb-2"
              inputType="currency"
              label="Diesel Price"
              name="dieselPrice"
              value={this.state.dieselPrice}
              onChange={this.handleInputChange}
              validation={this.validator.message(
                "diesel_price",
                this.state.dieselPrice,
                "maxDecimalPrecision:4"
              )}
            />
            {this.state.dieselTaxIncluded && (
              <p className="text-gray-600">Tax included in price</p>
            )}
          </div>
          <div className="flex flex-wrap">
            <FormGroup
              className="mb-2"
              inputType="currency"
              label="Propane Price"
              name="propanePrice"
              value={this.state.propanePrice}
              onChange={this.handleInputChange}
              validation={this.validator.message(
                "propane_price",
                this.state.propanePrice,
                "maxDecimalPrecision:4"
              )}
            />
            {this.state.propaneTaxIncluded && (
              <p className="text-gray-600">Tax included in price</p>
            )}
          </div>
          <NextButton
            processing={this.state.processing}
            click={() => this.submit()}
            text="Update Pump Prices"
            processingText="Updating Pump Prices..."
            btnClass="btn-primary h-10 mt-6 col-start-1 col-span-2 lg:col-span-1 lg:col-start-6"
          />
          {this.state.validationErrorMessage ? (
            <p className="text-status-red col-span-full">
              {this.state.validationErrorMessage}
            </p>
          ) : (
            ""
          )}
        </div>
      </div>
    )
  }
}

ListedPumpPricesForm.propTypes = {
  fuel: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string.isRequired,
      unitPrice: PropTypes.string,
      taxIncluded: PropTypes.bool.isRequired,
    })
  ).isRequired,
  lastUpdatedAt: PropTypes.string,
}

export default ListedPumpPricesForm
